import diverse from "../../assets/whyErp/diverse.svg";
import scalable from "../../assets/whyErp/scalable.svg";
import reduceExpances from "../../assets/whyErp/reduceExpances.svg";
import secure from "../../assets/whyErp/secure.svg";
import communication from "../../assets/whyErp/communication.svg";
import collaboration from "../../assets/whyErp/collaboration.svg";
import workload from "../../assets/whyErp/workload.svg";
import support from "../../assets/headSection/contactUs.svg";

export const whyErp = {
  title: "Why Dynamic Academic ERP for your Institution?",
  info: "A school ERP can offer many advantages such as faster workflow, better visibility, lower costs, and so on. Here are five main advantages why you need dynamic academic ERP.",
  reason: [
    {
      id: "1",
      type: "Diverse reporting",
      image: diverse,
      description:
        "Administrators of schools/institutes can generate a wide variety of reports for their daily tasks. They can also organize their institute administration effectively by looking at the detailed breakdown of the entire system.",
    },
    {
      id: "2",
      type: "Highly Scalable",
      image: scalable,
      description:
        "Our highly scalable systems are designed to store, process, and manage massive amounts of data without compromising efficiency, security, or reliability.",
    },
    {
      id: "3",
      image: secure,
      type: "Highly Secured",
      description:
        "Maintaining full data security and management can be impossible with manual work. Students' data can now be managed much easier than ever thanks to Dynamic Academic ERP software.",
    },
    {
      id: "4",
      image: support,
      type: "Amazing Support",
      description:
        "The team we have is the best-trained, and they have implemented the software in many BIG schools and colleges. For your schools/colleges/universities/coaching centers, we will provide the appropriate support so you do not have to worry about implementation.",
    },
    {
      id: "9",
      image: secure,
      type: "Privacy and security",
      description:
        "The data remains secure in our dynamic academic ERP. Since it's all in the cloud nobody has to worry about losing important documents & data.",
    },
    {
      id: "5",

      image: collaboration,
      type: "Improved collaboration between students and teachers",
      description:
        "Our academic ERP systems facilitate collaboration across the classroom beyond. By using this, students can gain access to online support and receive their queries answered. For students who are hesitant to ask questions during class, this can be an extremely helpful tool.",
    },
    {
      id: "6",
      image: communication,
      type: "Enhanced communication between parents and teachers",
      description:
        "Parents can also access their children's attendance, performance, or contact through the ERP system at any time even when they are busy. The teacher & parents can communicate more effectively & also there are timely updates.",
    },
    {
      id: "7",
      image: workload,
      type: "Assists in reducing administrative workload",
      description:
        "The entire process of admitting students or generating reports can be automated reducing errors & saving time. It allows students & educators to record attendance and create timetables, generate receipts, and send messages to parents without wasting much time.In addition to reports for teachers and school staff, these can be generated with a single click, saving valuable time.",
    },
    {
      id: "8",
      image: reduceExpances,
      type: "Reduces expenses and saves time",
      description:
        "Making use of the ERP system efficiently can maximize all aspects of the organization, from stationary to storage space. Furthermore, there is an increase in the efficiency of communication as you don't have to call parents to inform them about important school events; the ERP does that for you. Also, each individual will end up saving a lot of timethrough the automation features.",
    },
  ],
};
